import Switch from '../../atoms/switch';
import { Text } from 'src/modules/shared/components/atoms/text';
import { useWritingEnterKeyPreference } from 'src/modules/shared/hooks/use-writing-enter-key-preference';
import { useI18n } from 'src/modules/shared/hooks/provider-bounded/i18n';

/**
 * Browser-level setting for how Enter behaves while composing chat messages.
 */
export const EnterKeyModeSetting = () => {
  const { t } = useI18n();
  const { resolvedBehavior, setMode } = useWritingEnterKeyPreference();

  const handleToggleChange = (checked: boolean) => {
    setMode(checked ? 'send' : 'newline');
  };

  const isEnterToSendEnabled = resolvedBehavior === 'send';

  return (
    <div className="rounded-lg border border-secondary-200 bg-secondary-50 p-4">
      <div className="flex items-start justify-between gap-4">
        <div className="min-w-0 space-y-1">
          <Text weight="medium" className="text-sm text-secondary-800">
            {t('settings.preferences.messaging.writing.title')}
          </Text>
          <Text size="small" color="neutral">
            {t('settings.preferences.messaging.writing.description')}
          </Text>
        </div>

        <div className="pt-0.5">
          <Switch
            checked={isEnterToSendEnabled}
            onChange={handleToggleChange}
            variant="primary"
            size="sm"
            ariaLabel={t('settings.preferences.messaging.writing.title')}
          />
        </div>
      </div>
    </div>
  );
};
